import { HiddenInput, Input, Root } from './otp-field';

const OneTimePasswordField = {
	Root,
	Input,
	HiddenInput,
};

export { OneTimePasswordField };
